// React
import { useEffect } from "react";

// React Router
import { Outlet, useLocation } from "react-router-dom";

// Auth
import { initialAuthDomain } from "Auth/bootstrapAuth";
import { clearAppSessionStorage, getAuthDomainForPath } from "Auth/authUtils";

const AuthDomainRouter = () => {
  const location = useLocation();

  useEffect(() => {
    const currentDomain = getAuthDomainForPath(location.pathname);
    if (initialAuthDomain === currentDomain) {
      return;
    }

    clearAppSessionStorage();

    window.location.reload();
  }, [location.pathname]);

  return <Outlet />;
};

export default AuthDomainRouter;
